import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  coachPlanCancel,
  updateProfile,
} from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { curSym, pipViewDate2 } from "../../utils/pip";
import { Formik } from "formik";
import {
  changePasswordSchema,
  updateFreelancerProfileSchema,
} from "../../utils/schema";
import { coachPaths } from "../../routes/coach";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorMessage from "../../components/form/ErrorMessage";
import Eye from "../../components/form/Eye";
import CoachDisableConfirmationModal from "../../components/Modals/common/CoachDisableConfirmationModal";
import { State, City, Country } from "country-state-city";
import toast from "react-hot-toast";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import Offers from "../../components/pages/find-a-job/Offers";
import Availability from "../../components/pages/find-a-job/Availability";
import {
  changePassword,
  deleteAccount,
  disableAccount,
  fetchfreelancerProfile,
  fetchOffers,
  fetchSubscriptionData,
  freelancerUpdateProfile,
  raiseSupportTicket,
  fetchAllTickets,
} from "../../redux/features/find-a-job/actions/authAction";
import TagInput from "../../components/form/TagInput";
import { jobTypes } from "../../utils/data";
import ReactPagination from "../../components/table/ReactPagination";
import PaginationDropdown from "../../components/table/PaginationDropdown";
import TableHeader from "../../components/table/tableHeader";
import TicketDetailsModal from "../../components/Modals/common/TicketDetailsModal";

const formatPurchaseDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "long" }).toLowerCase();
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const Settings = () => {
  const { freelancerSubscriptionPlan, isLoading, freelancerProfileData, ticketList, subLoading } =
    useSelector((state) => state.freelancer.auth);
  const [accountInformation, setAccountInformation] = useState(() => {
    return localStorage.getItem("freelancer_settings_tab") || "Security";
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const location = useLocation();
  const { offerList } = useSelector((state) => state.freelancer.auth);

  const [isEye, setIsEye] = useState(false);
  const [isEye1, setIsEye1] = useState(false);

  const [isEye2, setIsEye2] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);

  const [isDeleteAccount, setIsDeleteAccount] = useState(false);
  const [isSubscriptionCancel, setIsSubscriptionCancel] = useState(false);
  const [activeTicket, setActiveTicket] = useState(null);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [language, setLanguages] = useState([""]);

  const [isRaiseForm, setIsRaiseForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);
  const [ticketImages, setTicketImages] = useState([]);
  const [ticketSubmitting, setTicketSubmitting] = useState(false);

  const initialValues = {
    new_password: "",
    current_password: "",
    confirm_password: "",
  };

  useEffect(() => {
    if (!freelancerProfileData?.open_talent?.language) {
      setLanguages([]);
      return;
    }
    const data = freelancerProfileData?.open_talent?.language
      .split(",")
      .map((item) => item.trim());
    setLanguages(data);
  }, [freelancerProfileData]);

  const initialValues1 = {
    first_name: freelancerProfileData?.first_name ?? "",
    last_name: freelancerProfileData?.last_name ?? "",
    email: freelancerProfileData?.email ?? "",
    talent_role: freelancerProfileData?.open_talent?.talent_role ?? "",
    location: freelancerProfileData?.open_talent?.location ?? "",
    bio: freelancerProfileData?.open_talent?.bio || "",
    skills: freelancerProfileData?.open_talent?.skills
      ? freelancerProfileData?.open_talent?.skills.split(",")
      : [],
    // language: freelancerProfileData?.open_talent?.language || "",
    website_or_portfolio:
      freelancerProfileData?.open_talent?.website_or_portfolio || [],
    dob: freelancerProfileData?.dob ?? null,
    gender: freelancerProfileData?.gender ?? null,
    phone_number: freelancerProfileData?.phone_number ?? "",
    city: freelancerProfileData?.open_talent?.city ?? "",
    country: freelancerProfileData?.open_talent?.country ?? "",
    state: freelancerProfileData?.open_talent?.state ?? "",
    address_1: freelancerProfileData?.open_talent?.address_1 ?? "",
    address_2: freelancerProfileData?.open_talent?.address_2 ?? "",
    zip_code: freelancerProfileData?.open_talent?.zip_code ?? "",
    job_type: freelancerProfileData?.open_talent?.job_type || "",
    search_status: freelancerProfileData?.open_talent?.search_status || "",
    salary_preference:
      freelancerProfileData?.open_talent?.salary_preference || "",
  };

  useEffect(() => {
    dispatch(fetchSubscriptionData());
    dispatch(fetchfreelancerProfile());
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
    if (location?.state?.tab) {
      setAccountInformation(location.state.tab);
      localStorage.setItem("freelancer_settings_tab", location.state.tab);
    }
  }, [location]);

  useEffect(() => {
    if (accountInformation == "Offers") dispatch(fetchOffers());
    if (accountInformation == "Ticket") dispatch(fetchAllTickets());
    localStorage.setItem("freelancer_settings_tab", accountInformation);
  }, [accountInformation]);

  useEffect(() => {
    return () => {
      ticketImages.forEach((item) => {
        if (item?.preview) {
          URL.revokeObjectURL(item.preview);
        }
      });
    };
  }, [ticketImages]);

  useEffect(() => {
    setCurrentPage(0);
  }, [ticketList, listPerPages]);

  const handleChangePassword = (values, resetForm) => {
    const callback = (response) => {
      if (response.success) {
        resetForm();
      }
    };
    const data = {
      old_password: values?.current_password,
      new_password: values?.new_password,
    };
    dispatch(changePassword({ payload: data, callback }));
  };

  const handleUpdateProfile = (values) => {
    const isAnyEmpty = language.some((item) => !item.trim());
    if (isAnyEmpty) {
      toast.error("Please fill all language fields or remove the empty ones.");
      return;
    }
    values.skills = values?.skills?.join(",");
    values.language = language?.join(",");
    values.gender = values?.gender == "" ? null : values?.gender;
    values.dob = values?.dob == "" ? null : values?.dob;
    delete values.email;
    const callback = (response) => {
      dispatch(fetchfreelancerProfile());
    };
    dispatch(freelancerUpdateProfile({ callback, payload: values }));
  };

  const handleDisableAccount = () => {
    const callback = (response) => {
      if (response.success) {
        localStorage.removeItem("freelancer_profile_nuvio");
        localStorage.removeItem("freelancer_token_nuvio");
        navigate(coachPaths?.WebinarData);
      }
    };
    dispatch(disableAccount({ callback }));
  };

  const handleDeleteAccount = () => {
    const callback = (response) => {
      if (response.success) {
        localStorage.removeItem("freelancer_profile_nuvio");
        localStorage.removeItem("freelancer_token_nuvio");
        navigate(coachPaths?.WebinarData);
      }
    };
    dispatch(deleteAccount({ callback }));
  };

  const handlePlanCancelSubScription = () => {
    const callback = (response) => {
      if (response.success) {
        dispatch(fetchSubscriptionData());
        setAccountInformation("Subscription");
        setIsSubscriptionCancel(false);
      }
    };
    dispatch(coachPlanCancel({ callback }));
  };

  const handleAddLanguage = () => {
    setLanguages((prev) => [...prev, ""]);
  };

  const handleLanguageChange = (index, newValue) => {
    const updated = [...language];
    updated[index] = newValue;
    setLanguages(updated);
  };

  const handleRemoveLanguage = (index) => {
    setLanguages((prev) => prev.filter((_, i) => i !== index));
  };
  const ticketInitialValues = {
    title: "",
    description: "",
    category: "",
  };

  const paginatedTicketList =
    ticketList?.slice(
      currentPage * listPerPages,
      (currentPage + 1) * listPerPages
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleTicketImagesSelect = (event) => {
    const files = Array.from(event.currentTarget.files || []);
    const imageFiles = files.filter((file) => file.type?.startsWith("image/"));
    if (files.length && imageFiles.length !== files.length) {
      toast.error("Only image files are allowed.");
    }
    if (imageFiles.length) {
      const nextItems = imageFiles.map((file) => ({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      }));
      setTicketImages((prev) => [...prev, ...nextItems]);
    }
    event.currentTarget.value = "";
  };

  const handleTicketImageRemove = (index) => {
    setTicketImages((prev) => {
      const next = [...prev];
      const removed = next.splice(index, 1);
      if (removed[0]?.preview) {
        URL.revokeObjectURL(removed[0].preview);
      }
      return next;
    });
  };

  const handleTicketSubmit = async (values, actions) => {
    if (ticketSubmitting) return;
    setTicketSubmitting(true);
    const formData = new FormData();
    formData.append("title", values.title || "");
    formData.append("description", values.description || "");
    formData.append("category", values.category || "");
    ticketImages.forEach((item) => {
      if (item?.file instanceof File) {
        formData.append("images", item.file);
      }
    });

    const callback = (response) => {
      if (response?.success) {
        actions.resetForm();
        setTicketImages([]);
        setIsRaiseForm(false);
        dispatch(fetchAllTickets());
      }
      setTicketSubmitting(false);
    };
    dispatch(raiseSupportTicket({ payload: formData, callback }));
  };

  if (isLoading || subLoading) {
    return <Loader />;
  }
  return (
    <FreelancerLayout>
      <div className="mt-4 ct_px_40 pb-5">
        <div className="ct_mb_20">
          <h4 className="ct_fs_20_new ct_fw_600 ct_darkblue_text">Settings</h4>
          <p className="mb-0 ct_grey_text">
            Manage your account settings and set e-mail prefernces
          </p>
        </div>

        <div className="row ct_pt_20 ct_border_top_1_op_10 ct_mt_20">
          <div className="col-lg-3 mb-4 ">
            <div className="ct_setting_tabs">
              <div
                class="nav flex-column nav-pills me-3"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                {/* <button
                  class={`nav-link ${accountInformation == "Account" && "active"
                    }`}
                  id="v-pills-Account-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Account"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Account"
                  aria-selected="true"
                  onClick={() => setAccountInformation("Account")}
                >
                  Account
                </button> */}
                <button
                  class={`nav-link ${accountInformation == "Security" && "active"
                    }`}
                  id="v-pills-Security_&_Password-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Security_&_Password"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Security_&_Password"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Security")}
                >
                  Security & Password
                </button>
                {freelancerProfileData?.open_talent?.talent_type ==
                  "FREELANCER" && (
                    <button
                      class={`nav-link ${accountInformation == "Subscription" && "active"
                        }`}
                      id="v-pills-Subscription_&_Plan-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-Subscription_&_Plan"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-Subscription_&_Plan"
                      aria-selected="false"
                      onClick={() => setAccountInformation("Subscription")}
                    >
                      Subscription & Plan
                    </button>
                  )}
                <button
                  class={`nav-link ${accountInformation == "Notifications" && "active"
                    }`}
                  id="v-pills-Notifications-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Notifications"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Notifications"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Notifications")}
                >
                  Notifications
                </button>

                <button
                  class={`nav-link ${accountInformation == "Offers" && "active"
                    }`}
                  id="v-pills-Offers-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Offers"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Offers"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Offers")}
                >
                  Offers
                </button>
                {freelancerProfileData?.open_talent?.talent_type ==
                  "FREELANCER" && (
                    <button
                      class={`nav-link ${accountInformation == "Availability" && "active"
                        }`}
                      id="v-pills-Availability-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-Availability"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-Availability"
                      aria-selected="false"
                      onClick={() => setAccountInformation("Availability")}
                    >
                      Availability
                    </button>
                  )}
                {/* {freelancerProfileData?.open_talent?.talent_type ==
                  "FREELANCER" && ( */}
                <button
                  class={`nav-link ${accountInformation == "Ticket" && "active"
                    }`}
                  id="v-pills-Ticket-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-Ticket"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-Ticket"
                  aria-selected="false"
                  onClick={() => setAccountInformation("Ticket")}
                >
                  Report an issue
                </button>
                {/* )} */}
              </div>
            </div>
          </div>
          <div className="col-lg-9  mb-4 ">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class={`tab-pane fade ${accountInformation == "Account" && "show active"
                  }`}
                id="v-pills-Account"
                role="tabpanel"
                aria-labelledby="v-pills-Account-tab"
              >
                <div className="ct_px_40">
                  <div>
                    <div>
                      <h4 className="ct_fs_16 ct_darkblue_text">
                        Account Information
                      </h4>
                      <p className="mb-0 ct_grey_text">
                        Ths is how others will see you on the Nuvio Platform
                      </p>
                    </div>
                    <Formik
                      initialValues={initialValues1}
                      validationSchema={updateFreelancerProfileSchema}
                      onSubmit={(values, actions) => {
                        handleUpdateProfile(values);
                      }}
                      enableReinitialize
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        setTouched,
                      }) => (
                        <form className="mt-4">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  First Name
                                </label>
                                <input
                                  value={values?.first_name}
                                  id="first_name"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  type="text"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter first name"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"first_name"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Last Name
                                </label>
                                <input
                                  value={values?.last_name}
                                  id="last_name"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  type="text"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter full name"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"last_name"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Email
                                </label>
                                <input
                                  value={values?.email}
                                  readOnly
                                  type="email"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter email"
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"email"}
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_grey_text">
                                  Role
                                </label>
                                <input
                                  class="form-control ct_input_border_8"
                                  placeholder="Role"
                                  type="text"
                                  id="talent_role"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.talent_role}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="talent_role"
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_grey_text">
                                  Location
                                </label>
                                <textarea
                                  class="form-control ct_input_border_8 h-auto"
                                  rows={2}
                                  placeholder="Location"
                                  type="text"
                                  id="location"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.location}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="location"
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_grey_text">
                                  Bio
                                </label>
                                <textarea
                                  class="form-control ct_input_border_8 h-auto"
                                  rows={4}
                                  placeholder="Bio"
                                  type="text"
                                  id="bio"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.bio}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="bio"
                                />
                              </div>
                            </div>

                            <TagInput
                              label="Skills"
                              placeholder="Type to add skills..."
                              name="skills"
                              value={values.skills}
                              onChange={setFieldValue}
                              error={touched.skills && errors.skills}
                            />

                            {/* <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_grey_text">
                                  Language
                                </label>
                                <input
                                  class="form-control ct_input_border_8"
                                  placeholder="Language"
                                  type="text"
                                  id="language"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.language}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"language"}
                                />
                              </div>
                            </div> */}

                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                  Portfolio or Website
                                </label>
                                <input
                                  class="form-control ct_input"
                                  placeholder="Portfolio or website"
                                  type="text"
                                  id="website_or_portfolio"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.website_or_portfolio || ""}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"website_or_portfolio"}
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                  Job types you’re open to
                                </label>

                                {/* add active class when we click on button  */}
                                <div className="d-flex align-items-center gap-3 flex-wrap">
                                  {jobTypes?.map((item, idx) => {
                                    return (
                                      <button
                                        type="button"
                                        key={idx}
                                        className={`ct_yellow_btn py-2 px-4 ct_job_type_btn  ct_outline_grey ${values?.job_type === item?.value
                                          ? "active"
                                          : ""
                                          }`}
                                        onClick={() => {
                                          setFieldValue(
                                            "job_type",
                                            item?.value
                                          );
                                          setTouched((prev) => ({
                                            ...prev,
                                            job_type: true,
                                          }));
                                        }}
                                      >
                                        {item?.label}
                                      </button>
                                    );
                                  })}
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"job_type"}
                                />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-3 d-block ct_fs_14 ct_darkblue_text">
                                  Job Search Status
                                </label>
                                <div>
                                  <div class="ct_radio-container ct_radio_container_yellow gap-0">
                                    <div class="ct_radio-wrapper">
                                      <label class="ct_radio-button">
                                        <input
                                          id="option1"
                                          name="ct_radio-group"
                                          type="radio"
                                          value="AVAILABLE"
                                          checked={
                                            values.search_status === "AVAILABLE"
                                          }
                                          onChange={() =>
                                            setFieldValue(
                                              "search_status",
                                              "AVAILABLE"
                                            )
                                          }
                                        />
                                        <span class="ct_radio-checkmark"></span>
                                      </label>
                                    </div>
                                    <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                      Available Now
                                    </p>
                                  </div>
                                  <div class="ct_radio-container ct_radio_container_yellow gap-0 mt-3">
                                    <div class="ct_radio-wrapper">
                                      <label class="ct_radio-button">
                                        <input
                                          id="option1"
                                          name="ct_radio-group"
                                          type="radio"
                                          value="WORKING"
                                          checked={
                                            values.search_status === "WORKING"
                                          }
                                          onChange={() =>
                                            setFieldValue(
                                              "search_status",
                                              "WORKING"
                                            )
                                          }
                                        />
                                        <span class="ct_radio-checkmark"></span>
                                      </label>
                                    </div>
                                    <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                      Currently Working on a Project
                                    </p>
                                  </div>

                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName={"search_status"}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group mb-4">
                                <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                  Salary Preferences
                                </label>
                                <input
                                  class="form-control ct_input"
                                  placeholder="Salary preferences"
                                  type="text"
                                  name="salary_preference"
                                  value={values.salary_preference || ""}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />

                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"salary_preference"}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Date Of Birth
                                </label>
                                <input
                                  type="date"
                                  className="form-control ct_input_border_8"
                                  value={values?.dob}
                                  id="dob"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  max={new Date().toISOString().split("T")[0]}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"dob"}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2  ct_fs_14 ct_grey_text">
                                  Gender
                                </label>
                                <div className="d-flex flex-column gap-2 position-relative">
                                  <select
                                    className="form-control ct_input_border_8"
                                    id="gender"
                                    value={values?.gender}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  >
                                    <option value="">Please select gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                  </select>
                                  <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"gender"}
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Phone Number
                                </label>
                                <input
                                  type="text"
                                  placeholder="Phone Number"
                                  className="form-control ct_input ct_input_border_8"
                                  id="phone_number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values?.phone_number}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"phone_number"}
                                />
                              </div>
                            </div>

                            {/* <div className="col-md-6"></div> */}
                          </div>
                          <div className="mt-2">
                            <div>
                              <h4 className="ct_fs_16 ct_darkblue_text">
                                Region & Language
                              </h4>
                              <p className="mb-0 ct_grey_text">
                                Ths is how others will see you on the Nuvio
                                Platform
                              </p>
                            </div>
                            <div className="mt-4">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Country
                                    </label>
                                    <div className="d-flex flex-column gap-2 position-relative">
                                      <select
                                        className="form-control ct_input_border_8"
                                        id="country"
                                        value={values.country}
                                        onChange={(e) => {
                                          const countryName = e.target.value;
                                          handleChange(e);

                                          const selectedCountry = countries.find(
                                            (c) => c.name === countryName
                                          );

                                          if (selectedCountry) {
                                            const statesData =
                                              State.getStatesOfCountry(
                                                selectedCountry.isoCode
                                              );
                                            setStates(statesData);
                                            setCities([]);
                                            setFieldValue("state", "");
                                            setFieldValue("city", "");
                                          } else {
                                            setStates([]);
                                            setCities([]);
                                          }
                                        }}
                                        onBlur={handleBlur}
                                      >
                                        <option value="">
                                          -- Select Country --
                                        </option>
                                        {countries.map((country) => (
                                          <option
                                            key={country.isoCode}
                                            value={country.name}
                                          >
                                            {country.name}
                                          </option>
                                        ))}
                                      </select>
                                      <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                    </div>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"country"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      State
                                    </label>
                                    <div className="d-flex flex-column gap-2 position-relative">
                                      <select
                                        className="form-control ct_input_border_8"
                                        id="state"
                                        value={values.state}
                                        onChange={(e) => {
                                          const stateName = e.target.value;
                                          handleChange(e);

                                          const selectedCountry = countries.find(
                                            (c) => c.name === values.country
                                          );

                                          const selectedState = states.find(
                                            (s) => s.name === stateName
                                          );

                                          if (selectedCountry && selectedState) {
                                            const citiesData =
                                              City.getCitiesOfState(
                                                selectedCountry.isoCode,
                                                selectedState.isoCode
                                              );
                                            setCities(citiesData);
                                            setFieldValue("city", "");
                                          } else {
                                            setCities([]);
                                          }
                                        }}
                                        onBlur={handleBlur}
                                        disabled={!values.country}
                                      >
                                        <option value="">
                                          -- Select State --
                                        </option>
                                        {states.map((state) => (
                                          <option
                                            key={state.isoCode}
                                            value={state.name}
                                          >
                                            {state.name}
                                          </option>
                                        ))}
                                      </select>
                                      <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                    </div>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"state"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Address Line 1
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Address line 1"
                                      id="address_1"
                                      value={values.address_1}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"address_1"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Address Line 2
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Type here"
                                      id="address_2"
                                      value={values.address_2}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"address_2"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      City
                                    </label>
                                    <div className="d-flex flex-column gap-2 position-relative">
                                      <select
                                        className="form-control ct_input_border_8"
                                        id="city"
                                        value={values.city}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!values.state}
                                      >
                                        <option value="">
                                          -- Select City --
                                        </option>
                                        {cities.map((city) => (
                                          <option
                                            key={city.name}
                                            value={city.name}
                                          >
                                            {city.name}
                                          </option>
                                        ))}
                                      </select>
                                      <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                    </div>
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"state"}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group mb-4">
                                    <label className="mb-2 ct_fs_14 ct_grey_text">
                                      Zip/Postal Code
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control ct_input_border_8"
                                      placeholder="Type here"
                                      id="zip_code"
                                      value={values?.zip_code}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <ErrorMessage
                                      errors={errors}
                                      touched={touched}
                                      fieldName={"zip_code"}
                                    />
                                  </div>
                                </div>

                                {language.map((lang, index) => (
                                  <div className="col-md-6">
                                    <div
                                      key={index}
                                      className="d-flex gap-2 mb-2"
                                    >
                                      <input
                                        type="text"
                                        value={lang}
                                        onChange={(e) =>
                                          handleLanguageChange(
                                            index,
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter language"
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveLanguage(index)
                                        }
                                        className="btn btn-danger ct_white_nowrap"
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                <span
                                  className="ct_darksky_blue_text ct_fw_600 mb-0 mt-2 ct_cursor_pointer"
                                  style={{ width: "fit-content" }}
                                  onClick={handleAddLanguage}
                                >
                                  <i className="fa-solid fa-plus ct_fs_14"></i>{" "}
                                  Add Language
                                </span>
                              </div>
                              <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                                <button
                                  className="ct_yellow_btn ct_grey_btn ct_h_44 px-5"
                                  type="button"
                                >
                                  Cancel
                                </button>
                                <button
                                  className="ct_yellow_btn  ct_sky_blue_btn ct_h_44 px-5"
                                  onClick={handleSubmit}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Subscription" && "show active"
                  }`}
                id="v-pills-Subscription_&_Plan"
                role="tabpanel"
                aria-labelledby="v-pills-Subscription_&_Plan-tab"
              >
                <div>
                  <h4 className="ct_fs_16 ct_darkblue_text">
                    Subscription Plan
                  </h4>
                  <p className="mb-0 ct_grey_text">
                    You can always upgrade for better visibility and client
                  </p>
                </div>
                {freelancerSubscriptionPlan &&
                  freelancerSubscriptionPlan?.length != 0 &&
                  freelancerSubscriptionPlan?.slice(0, 1)?.map((item) => (
                    <div className="row ct_mt_60">
                      <div className="col-lg-6 mb-4 mb-lg-0">
                        <div
                          className="ct_light_yellow_subscription_bg"
                          style={{ backgroundColor: "#F5F3FF" }}
                        >
                          <div className="d-flex align-items-start gap-3 justify-content-between">
                            <div>
                              <h4 className="ct_fs_14 ct_fw_600 ct_darkblue_text mb-1">
                                {item?.title || ""}
                              </h4>
                              <p className="ct_fs_12 ct_darkblue_text mb-1">{item?.description ?? ""}</p>

                            </div>
                            <div className="text-end">
                              <button className="ct_white_btn ct_white_nowrap">
                                Upgrade Plan
                              </button>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                            <div>
                              <h4 className="ct_fs_24_new ct_fw_500">
                                {Number(item?.total_price ?? 0) === 0 ? (
                                  <span className="ct_fw_600 ct_orange_text">Free</span>
                                ) : (
                                  <>
                                    {curSym}
                                    {item?.total_price} &nbsp;
                                    <small className="ct_fs_14">USD</small>
                                  </>
                                )}
                              </h4>
                              <p className="ct_fs_14 ct_grey_text">
                                {Number(item?.total_price ?? 0) === 0
                                  ? ""
                                  : "Price per month"}
                              </p>
                              {/* {!item?.auto_pay && */}
                              <div className="ct_day_left_design d-inline-flex align-items-center gap-2 ct_fs_12">
                                <i className="fa-solid fa-circle-exclamation"></i>
                                {Number(item?.total_price ?? 0) == 0
                                  ? `Free trial - ${item?.days_left ?? 0} days left`
                                  : `${item?.title || ""} ${item?.days_left ?? 0} days left`}
                              </div>
                              {/* } */}
                            </div>
                            <div className="ct_right_vector_img_subs">
                              <img src="../assets/img/cuate.png" />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {item?.auto_pay && (
                        <div className="col-lg-6 mb-4 mb-lg-0 pe-5">
                          <div className="ct_white_border_bg d-block">
                            <div className="d-flex align-items-start justify-content-between gap-3">
                              <p className="ct_fs_14 mb-0">NEXT BILLING DATE</p>
                              <button
                                className="ct_red_btn_12 ct_white_nowrap"
                                onClick={() => setIsSubscriptionCancel(true)}
                              >
                                Cancel Plan
                              </button>
                            </div>
                            <div className="mt-4">
                              <h3 className="ct_fs_21 mb-2">
                                {pipViewDate2(item?.next_billing_date)}
                              </h3>
                              <p className="ct_grey_text ct_fs_14 mb-0">
                                This is your next billing date
                              </p>
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  ))}
                <div className="row ct_border_top_1_op_10 ct_mt_40 ct_pt_40">
                  <div className="col-lg-12 pe-5">
                    <div className="">
                      <div className="mb-4 d-flex align-items-center gap-3 justify-content-between ct_flex_col_575">
                        <div>
                          <p className="ct_darkblue_text mb-1">
                            Payment Method
                          </p>
                          <p className="ct_grey_text ct_fs_14 mb-0">
                            Manage your payment methods here.
                          </p>
                        </div>
                      </div>
                      <div className="ct_payment_options_list">
                        <ul className="mb-0">
                          <li className="ct_payments_option_card">
                            <div className="d-flex align-items-center gap-3">
                              <img src="../assets/img/Visa.png" />
                              <div>
                                <h6 className="ct_fs_16 mb-1">
                                  <span className="me-2">
                                    {" "}
                                    Visa Debit Card{" "}
                                  </span>
                                  <span
                                    className="ct_default_badge ct_orange_text "
                                    style={{
                                      background: "hsl(32deg 100% 49% / 20%)",
                                    }}
                                  >
                                    Default
                                  </span>
                                </h6>
                                <p className="mb-0 ct_grey_text ct_fs_12">
                                  **** **** **** 2897
                                </p>
                              </div>
                            </div>
                            <div>
                              <img src="../assets/img/Delete_card.png" />
                            </div>
                          </li>
                          <li className="ct_payments_option_card">
                            <div className="d-flex align-items-center gap-3">
                              <img src="../assets/img/mastercard.png" />
                              <div>
                                <h6 className="ct_fs_16 mb-1">
                                  <span className="me-2"> Mastercard </span>
                                  <span
                                    className="ct_default_badge ct_darkblue_text "
                                    style={{
                                      background: "hsl(199deg 64% 73% / 50%)",
                                    }}
                                  >
                                    Default
                                  </span>
                                </h6>
                                <p className="mb-0 ct_grey_text ct_fs_12">
                                  **** **** **** 2897
                                </p>
                              </div>
                            </div>
                            <div>
                              <img src="../assets/img/Delete_card.png" />
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="ct_border_top_1_op_10 pt-3 ct_mt_40">
                        <h4 className="ct_fs_18 mb-3">
                          Add New Payment Method
                        </h4>
                        <div className="mt-4">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Name on Card
                                </label>
                                <input
                                  type="text"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter Name on Card"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Expiry
                                </label>
                                <input
                                  type="date"
                                  className="form-control ct_input_border_8"
                                  placeholder=" Type here"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2  ct_fs_14 ct_grey_text">
                                  Card number
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="number"
                                    className="form-control ct_input_border_8"
                                    style={{ paddingLeft: "60px" }}
                                    placeholder="Enter  Card number"
                                  />
                                  <div className="ct_input_icon_left">
                                    <svg
                                      width="34"
                                      height="24"
                                      viewBox="0 0 34 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="33"
                                        height="23"
                                        rx="3.5"
                                        fill="white"
                                      />
                                      <rect
                                        x="0.5"
                                        y="0.5"
                                        width="33"
                                        height="23"
                                        rx="3.5"
                                        stroke="#F5F5F5"
                                      />
                                      <path
                                        d="M21.5771 5.03125C25.322 5.03125 28.3584 8.03114 28.3584 11.7314C28.3583 15.4317 25.322 18.4316 21.5771 18.4316C19.8982 18.4316 18.3629 17.8269 17.1787 16.8281C15.9945 17.8267 14.4591 18.4316 12.7803 18.4316C9.03566 18.4314 6.00011 15.4315 6 11.7314C6 8.03127 9.03559 5.03147 12.7803 5.03125C14.459 5.03125 15.9945 5.63533 17.1787 6.63379C18.3629 5.63519 19.8983 5.03128 21.5771 5.03125Z"
                                        fill="#ED0006"
                                      />
                                      <path
                                        d="M21.5771 5.03125C25.322 5.03133 28.3574 8.03119 28.3574 11.7314C28.3573 15.4316 25.3219 18.4316 21.5771 18.4316C19.8982 18.4316 18.3629 17.8268 17.1787 16.8281C18.6359 15.5993 19.5615 13.7727 19.5615 11.7314C19.5615 9.68995 18.6361 7.86269 17.1787 6.63379C18.3629 5.63525 19.8984 5.03125 21.5771 5.03125Z"
                                        fill="#F9A000"
                                      />
                                      <path
                                        d="M17.1787 6.63281C18.6363 7.86171 19.5615 9.68883 19.5615 11.7305C19.5615 13.7719 18.636 15.5983 17.1787 16.8271C15.7217 15.5983 14.7969 13.7716 14.7969 11.7305C14.7969 9.68913 15.7215 7.86171 17.1787 6.63281Z"
                                        fill="#FF5E00"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  CVV
                                </label>
                                <input
                                  type="number"
                                  className="form-control ct_input_border_8"
                                  placeholder="Enter CVV"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            <button
                              className="ct_yellow_btn px-5"
                            >
                              Add Payment Method
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Security" && "show active"
                  }`}
                id="v-pills-Security_&_Password"
                role="tabpanel"
                aria-labelledby="v-pills-Security_&_Password-tab"
              >
                <div>
                  <h4 className="ct_fs_16 ct_darkblue_text">Change Password</h4>
                  <p className="mb-0 ct_grey_text">
                    Changing your password will log out of all your active
                    sessions
                  </p>
                </div>
                <Formik
                  initialValues={initialValues}
                  enableReinitialize
                  validationSchema={changePasswordSchema}
                  onSubmit={(values, actions) => {
                    handleChangePassword(values, actions.resetForm);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    resetForm,
                  }) => (
                    <form className="mt-4">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              Current Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye ? "text" : "password"}
                                className="form-control ct_input ct_input_border_8 pe-5"
                                placeholder="Current Password"
                                id="current_password"
                                value={values.current_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye}
                                onClick={() => setIsEye(!isEye)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="current_password"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              New Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye1 ? "text" : "password"}
                                className="form-control ct_input ct_input_border_8 pe-5"
                                placeholder="New Password"
                                id="new_password"
                                value={values.new_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye1}
                                onClick={() => setIsEye1(!isEye1)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="new_password"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="mb-2 ct_fs_14 ct_grey_text">
                              Confirm Password
                            </label>
                            <div className="position-relative">
                              <input
                                type={isEye2 ? "text" : "password"}
                                className="form-control ct_input ct_input_border_8 pe-5"
                                placeholder="Confirm Password"
                                id="confirm_password"
                                value={values?.confirm_password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                              />
                              <Eye
                                isEye={isEye2}
                                onClick={() => setIsEye2(!isEye2)}
                              />
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="confirm_password"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 mt-4">
                        <button
                          className="ct_yellow_btn ct_outline_light_grey px-5"
                          type="button"
                          onClick={() => resetForm()}
                        >
                          Discard
                        </button>
                        <button
                          className="ct_yellow_btn px-5"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Save New Password
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
                <div
                  className="ct_no_factor_Authentication_outline"
                  style={{ marginTop: "80px" }}
                >
                  <p className="mb-0 ct_fs_18">Two- Factor Authentication</p>
                  <div class="d-flex align-items-center gap-2">
                    <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                      <input type="checkbox" />
                      <div class="toggle-switch-background">
                        <div class="toggle-switch-handle"></div>
                      </div>
                    </label>
                    <span className="ct_white_nowrap"> Disabled</span>
                  </div>
                </div>

                <div className="ct_mt_30">
                  <h6 className="ct_fs_18 mb-3">Profile Privacy</h6>
                  <ul>
                    <li>
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">
                            Hide Number of Hired Candidates
                          </h6>
                          <p className="ct_grey_text mb-0">
                            You can make some details of your jobs on the
                            marketplace private
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="ct_mt_30">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Reset Account</h6>
                          <p className="ct_grey_text mb-0">
                            Choose this to irreversibly remove your account and
                            data, ensuring no future access or recovery.
                          </p>

                          <button
                            className="ct_yellow_btn ct_sky_light_btn_new mt-2 ct_border_radius_100 ct_h_48"
                            onClick={() => setIsModalShow(true)}
                          >
                            Disable Account
                          </button>
                        </div>
                      </div>
                    </li>
                    <li className="ct_mt_30">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Delete My Account</h6>
                          <p className="ct_grey_text mb-0">
                            Choose this to irreversibly remove your account and
                            data, ensuring no future access or recovery.
                          </p>

                          <button
                            className="ct_yellow_btn ct_orange_btn mt-2 ct_border_radius_100 ct_h_48"
                            onClick={() => setIsDeleteAccount(true)}
                          >
                            Delete My Account
                          </button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class={`tab-pane fade ${accountInformation == "Notifications" && "show active"
                  }`}
                id="v-pills-Notifications"
                role="tabpanel"
                aria-labelledby="v-pills-Notifications-tab"
              >
                <div className="">
                  <div className="mb-4">
                    <h6 className="ct_fs_18 mb-1">Job</h6>
                    <p className="ct_fs_14 ct_grey_text">
                      You can create some notifications for job alerts
                    </p>
                  </div>
                  <ul>
                    <li>
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">New Job Matches</h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            Be the first to get job notification once posted on
                            the platform
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Application Updates</h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            You can make some details of your jobs on the
                            marketplace private
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">
                            Platform Announcement
                          </h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            Be the first to get job notification once posted on
                            the platform
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">
                            Job Offers and Updates
                          </h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            Be the first to get job notification once posted on
                            the platform
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">Referrals</h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            Be the first to get job notification once posted on
                            the platform
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                    <li className="mt-4">
                      <div className="ct_no_factor_Authentication_outline align-items-start ct_py_15_px_20">
                        <div>
                          <h6 className="mb-2 ct_fs_18">
                            Reminder to Review New Talents
                          </h6>
                          <p className="ct_grey_text mb-0 ct_fs_14">
                            Be the first to get job notification once posted on
                            the platform
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <label class="toggle-switch ct_toggle_switch_h_16 ">
                            <input type="checkbox" />
                            <div class="toggle-switch-background">
                              <div class="toggle-switch-handle"></div>
                            </div>
                          </label>
                          <span className="ct_white_nowrap">Enable</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <Offers
                accountInformation={accountInformation}
                data={offerList}
              />
              {freelancerProfileData?.open_talent?.talent_type ==
                "FREELANCER" && (
                  <Availability accountInformation={accountInformation} />
                )}
              <div
                class={`tab-pane fade ${accountInformation == "Ticket" && "show active"
                  }`}
                id="v-pills-Ticket"
                role="tabpanel"
                aria-labelledby="v-pills-Ticket-tab"
              >
                <div className="">
                  <div className="mb-4 d-flex align-items-center justify-content-between">
                    <div className="">
                      <h6 className="ct_fs_18 mb-0">Raise Your NUVIO Support Ticket</h6>
                      <p className="ct_fs_14 ct_grey_text">
                        We've got you back! Fill this in and our team will jump on it fast.
                      </p>
                    </div>
                    {!isRaiseForm &&
                      <button
                        className="ct_yellow_btn ct_sky_blue_btn ct_h_44"
                        onClick={() => setIsRaiseForm(true)}
                      >
                        Submit & Let's Fix It!
                      </button>
                    }
                  </div>
                  {!isRaiseForm ?
                    <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                      <table class="table">
                        <TableHeader
                          data={[
                            "#",
                            "Title",
                            "Description",
                            "Category",
                            "Action"
                          ]}
                        />
                        {paginatedTicketList?.length > 0 && (
                          <tbody>
                            {paginatedTicketList?.map((item, index) => (
                              <tr>
                                <td>{currentPage * listPerPages + index + 1}</td>
                                <td className="text-capitalize">
                                  {item?.title || "#N/A"}{" "}
                                </td>
                                <td>
                                  <span className="ct_pverlay_text d-inline-block">
                                    {item?.description || "#N/A"}
                                  </span>
                                </td>
                                <td>{item?.category || "#N/A"}</td>
                                <td>
                                  <div class="ct_right_dropdown dropdown">
                                    <i
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={() => setActiveTicket(item)}
                                      class="fa-solid fa-eye"
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </table>
                      {ticketList?.length <= 0 && (
                        <div className="text-center ct_grey_text py-4">
                          No tickets found.
                        </div>
                      )}
                    </div>
                    :
                    <Formik
                      initialValues={ticketInitialValues}
                      validate={(values) => {
                        const errors = {};
                        if (!values.title?.trim()) {
                          errors.title = "Title is required";
                        }
                        if (!values.description?.trim()) {
                          errors.description = "Description is required";
                        }
                        if (!values.category?.trim()) {
                          errors.category = "Category is required";
                        }
                        return errors;
                      }}
                      onSubmit={handleTicketSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        resetForm,
                      }) => (
                        <form className="mt-4" onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  What's Happening? (Title)
                                </label>
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control ct_input  pe-5"
                                    placeholder="What's Happening?"
                                    id="title"
                                    value={values.title}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  />
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="title"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="mb-2 ct_fs_14 ct_grey_text">
                                  Tell us more, share the full story—steps, errors, screenshots—everything that helps us fix it faster.
                                </label>
                                <div className="position-relative">
                                  <textarea
                                    rows="4"
                                    className="form-control ct_input h-auto"
                                    placeholder="Tell us more, share the full story—steps, errors, screenshots—everything that helps us fix it faster."
                                    id="description"
                                    value={values.description}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  />
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName="description"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-4">
                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                  Category
                                </label>
                                <div className="d-flex flex-column gap-2 position-relative">
                                  <select
                                    className="form-control ct_fs_12 ct_input"
                                    id="category"
                                    value={values.category}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                  >
                                    <option value="">--- Select category ---</option>
                                    <option value="Tech Trouble">Tech Trouble</option>
                                    <option value="Billing/Payment">Billing/Payment</option>
                                    <option value="Account/Login">Account/Login</option>
                                    <option value="Feature Request">Feature Request</option>
                                    <option value="Something Else">Something Else</option>
                                  </select>
                                  <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                </div>
                                <ErrorMessage
                                  errors={errors}
                                  touched={touched}
                                  fieldName={"category"}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group mb-4">
                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                  Attachments (Images)
                                </label>
                                <div className="ct_ticket_upload_area">
                                  <label className="ct_upload_btn ct_ticket_upload_btn">
                                    <i className="fa-solid fa-cloud-arrow-up"></i>
                                    Upload Images
                                    <input
                                      className="ct_file_input"
                                      type="file"
                                      multiple
                                      accept="image/*"
                                      onChange={handleTicketImagesSelect}
                                    />
                                  </label>
                                  <p className="ct_fs_12 ct_grey_text mb-0">
                                    You can upload multiple screenshots or images.
                                  </p>
                                </div>
                                {ticketImages.length > 0 && (
                                  <div className="ct_ticket_upload_grid mt-3">
                                    {ticketImages.map((item, index) => (
                                      <div
                                        className="ct_ticket_thumb"
                                        key={`${item.name}-${index}`}
                                      >
                                        <img src={item.preview} alt={item.name} />
                                        <button
                                          type="button"
                                          className="ct_ticket_thumb_remove"
                                          onClick={() => handleTicketImageRemove(index)}
                                        >
                                          <i className="fa-solid fa-xmark"></i>
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="d-flex align-items-center  gap-3 mt-4">
                            <button
                              className="ct_yellow_btn ct_outline_light_grey px-5"
                              type="button"
                              onClick={() => {
                                resetForm();
                                setTicketImages([]);
                                setIsRaiseForm(false);
                              }}
                            >
                              Discard
                            </button>
                            <button
                              className="ct_yellow_btn px-5"
                              type="submit"
                              disabled={ticketSubmitting || isLoading}
                            >
                              Submit Ticket
                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  }
                  {!isRaiseForm &&
                    ticketList?.length != 0 && (
                      <div className="d-flex justify-content-between align-items-center mt-4 ">
                        <div>
                          {pathname != coachPaths?.CoachSettings && (
                            <PaginationDropdown
                              onChange={(val) => {
                                setListPerPages(val);
                                setCurrentPage(0);
                              }}
                            />
                          )}
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(
                              (ticketList?.length || 0) / listPerPages
                            )}
                            onPageChange={handlePageClick}
                            currentPage={currentPage}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 
      <div
        class="modal fade modal-lg"
        id="ct_add_payment_method"
        tabindex="-1"
        aria-labelledby="ct_create_eventLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body px-5 pb-5 ">
              <div className="text-center">
                <h4 class=" mb-1 ct_fs_24_new ct_darkblue_text px-4">
                  Payment method
                </h4>
                <p class="mb-0 ct_grey_text ct_fs_12 px-4">
                  Update, change, or add a payment method securely for
                  hassle-free billing.
                </p>
              </div>
              <div className="ct_mt_30">
                <div className="form-check ct_custom_check2 ct_custom_check_sky_blue  d-flex align-items-center gap-2 mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                  <label for="" className="ct_darkblue_text">
                    Business Purchase
                  </label>
                </div>

                <div className="mb-3">
                  <label className="ct_fs_14 ct_darkblue_text mb-2">
                    Choose payment method
                  </label>
                  <div className="d-flex align-items-center gap-3">
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/visa_big_logo.png" />
                    </div>
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/mastercard_small.png" />
                    </div>
                    <div className="ct_select_payment_type">
                      <img src="../assets/img/pay_pal.png" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Country{" "}
                      </label>
                      <select className="form-control ct_input">
                        <option>France</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Name on card
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Enter  name on card"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Card number
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Enter  card number"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Expiration date
                      </label>
                      <input type="date" className="form-control ct_input" />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group mb-2">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        CVC/CVV
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder=" CVC/CVV"
                      />
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
                  <button class="ct_yellow_btn ct_grey_btn ct_h_44  px-5">
                    <i
                      class="fa-solid fa-arrow-left me-1"
                      style={{ color: "#535862" }}
                    ></i>{" "}
                    Back
                  </button>
                  <button
                    class="ct_yellow_btn  ct_sky_blue_btn ct_h_44 px-5"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_submit_modal"
                  >
                    Add method
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div
        class="modal fade ct_submit_modal "
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#219EBC"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 mx-auto" style={{ maxWidth: "337px" }}>
                  Done! Your payment method is ready to use.
                </h4>
              </div>
              <div class="text-center mt-4">
                <button
                  class="ct_yellow_btn ct_h_48 mx-auto px-5 ct_sky_blue_btn"
                  data-bs-dismiss="modal"
                >
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> 
      */}

      {isModalShow && (
        <CoachDisableConfirmationModal
          onClose={() => setIsModalShow(false)}
          handleSubmit={handleDisableAccount}
          title="Disable Account"
          message="Are you sure you want to disable your account?"
        />
      )}
      {isDeleteAccount && (
        <CoachDisableConfirmationModal
          onClose={() => setIsDeleteAccount(false)}
          handleSubmit={handleDeleteAccount}
          title="Delete Account"
          message="Are you sure you want to delete your account? Once deleted, all your data will be permanently lost."
        />
      )}
      {isSubscriptionCancel && (
        <CoachDisableConfirmationModal
          onClose={() => setIsSubscriptionCancel(false)}
          handleSubmit={handlePlanCancelSubScription}
          title="Cancel Your Subscription"
          message="Are you sure you want to cancel your subscription?"
        />
      )}
      {activeTicket && (
        <TicketDetailsModal
          isOpen={!!activeTicket}
          onClose={() => setActiveTicket(null)}
          ticket={activeTicket}
        />
      )}
    </FreelancerLayout>
  );
};

export default Settings;



